import React, { useMemo } from "react";
import { MockedAuthManager } from "../../../contexts/AuthManager";
import { buildUser, buildWorkerProfile } from "../../factories";
import { Gender, ProfileType, WorkerProfileInput } from "../../../__generated__/graphql";
import type { Meta, StoryObj } from "@storybook/react";
import ChildrenEditorScreen from "../../../screens/profile-editor/ChildrenEditor";
import { MockedProvider } from "@apollo/client/testing/react";
import {
    MockedProfileSwitcherManager,
    ProfileIdType,
} from "../../../contexts/ProfileSwitcherManager";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { UPDATE_WORKER_PROFILE } from "../../../graphql/core";
import { StoryStackNavigatorContainer } from "../../display-helpers";

const Stack = createNativeStackNavigator<{
    ChildrenEdit: { profileId: ProfileIdType };
}>();

const StoryComponent = ({ withAdultChild }: { withAdultChild?: boolean }) => {
    const user = useMemo(
        () =>
            buildUser({
                workerProfile: buildWorkerProfile(
                    withAdultChild
                        ? {
                              hasChildren: true,
                              children: [
                                  {
                                      id: "child-adult",
                                      firstName: "Rui",
                                      lastName: "Silva",
                                      birthdate: "2005-04-02T00:00:00",
                                      gender: Gender.Male,
                                      avsNumber: null,
                                      monthlySalary: null,
                                      inFirstEducation: null,
                                      nationality: null,
                                      permitType: null,
                                  },
                              ],
                          }
                        : { hasChildren: null },
                ),
            }),
        [withAdultChild],
    );

    const mocks = useMemo(
        () => [
            {
                request: {
                    query: UPDATE_WORKER_PROFILE,
                    variables: () => true,
                },
                maxUsageCount: Number.POSITIVE_INFINITY,
                result: ({ changes }: { changes: WorkerProfileInput }) => {
                    // eslint-disable-next-line no-console
                    console.log("UPDATE_WORKER_PROFILE.changes", changes);
                    return {
                        data: {
                            updateWorkerProfile: buildWorkerProfile({
                                children: [],
                                hasFiscalAttestation: false,
                            }),
                        },
                    };
                },
            },
        ],
        [],
    );
    return (
        <MockedAuthManager user={user}>
            <MockedProfileSwitcherManager profileType={ProfileType.Worker}>
                <MockedProvider mocks={mocks}>
                    <StoryStackNavigatorContainer>
                        <Stack.Navigator initialRouteName="ChildrenEdit">
                            <Stack.Screen name="ChildrenEdit" component={ChildrenEditorScreen} />
                        </Stack.Navigator>
                    </StoryStackNavigatorContainer>
                </MockedProvider>
            </MockedProfileSwitcherManager>
        </MockedAuthManager>
    );
};

const meta = {
    title: "Screens/ProfileEditor/ChildrenEditor",
    component: StoryComponent,
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};

export const WithAdultChild: Story = { args: { withAdultChild: true } };
